// cspell: ignore putao,

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import utils from '../../lib/utils';
import { putaoWS } from '../../lib/ws';
import { Mask, HorizontalCenterDiv, Flex } from '../../lib/components/LessonPath/static/style';

import { Utils } from '../../utils/Utils';

export default class DownloadDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            progress: 0, // 100 —— 不显示下载按钮；0 —— 显示下载建议； 否则 —— 显示下载中
            startDownload: false,   //开始下载
            clickDownloadFlag: props.clickDownloadFlag, // 是否是直接点击下载，如果是就直接下载
        }
    }

    componentWillMount() {
        const that = this;
        window.download_pause = true;

        putaoWS.getCidDownloadProgress(utils.getQueryString('cid'), (data) => {
            if (data && data.progress !== undefined && data.progress !== null) {
                let tempProgress = parseInt(data.progress || 0, 10);

                that.setState({
                    progress: tempProgress  //window.download_pause ? 0 : tempProgress
                }, () => {
                    if (that.state.clickDownloadFlag) {
                        that.clickDownloadHandler();
                    }
                });
            }
        });
    }

    // 点击下载
    clickDownloadHandler = e => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const that = this;
        const { progress } = this.state;

        putaoWS.stopDownload();
        window.download_pause = false;

        Utils.getNeedDownloadVideoList(
            Object.assign(
                {
                    "needPreview": 1,
                    "cid": utils.getQueryString('cid')
                },
                this.context.user
            ), (lessons) => {

                that.setState({
                    startDownload: true
                });

                putaoWS.startDownload(lessons, (content) => {
                    console.log(content.cid + ": " + content.progress + "/100");
                    that.setState({
                        progress: Math.max(progress, parseInt(content && content.progress ? content.progress : progress, 10))   // 因为已存在的也返回进度，防止先取到了进度，然后开始下载进度又从 0 开始，所以取已有的最大值
                    });
                }, (error) => {
                    that.setState({
                        progress: progress || 0,
                        startDownload: false
                    }, () => {
                        utils.showTips(error.msg || '下载失败，请重试！', 3000);
                    });
                });
            });
    }

    // 点击直接上课
    clickStartLessonHandler = e => {
        e.preventDefault();
        e.stopPropagation();
        const { clickStartLessonHandler } = this.props;

        if (clickStartLessonHandler && typeof clickStartLessonHandler === 'function') {
            clickStartLessonHandler();
        }
    }

    // 点击取消
    cancelDownloadHandler = e => {
        e.preventDefault();
        e.stopPropagation();
        const { hideDownloadDialog } = this.props;

        putaoWS.stopDownload();
        window.download_pause = true;

        if (hideDownloadDialog && typeof hideDownloadDialog === 'function') {
            hideDownloadDialog();
        }
    }

    // 如果下载完了，点击空白区域是关闭弹窗，并且隐藏下载按钮
    closeMaskHandler = e => {
        const { progress } = this.state;
        const { hideDownloadDialog, hideDownloadButton } = this.props;

        if (progress === 100) {
            if (hideDownloadDialog && typeof hideDownloadDialog === 'function') {
                hideDownloadDialog();
            }

            if (hideDownloadButton && typeof hideDownloadButton === 'function') {
                hideDownloadButton();
            }
        }
    }

    render() {
        const { progress, startDownload } = this.state;

        return (
            <Mask opacity={0.7} zIndex={899} onClick={this.closeMaskHandler}>
                {startDownload ?
                    <DownloadBox>
                        <LoadingTaoTao />
                        <Title>下载学习资源中</Title>
                        <ProgressBar>
                            <Progress width={progress} />
                        </ProgressBar>
                        <Text>{progress >= 100 ? '已下载成功' : ``}</Text>
                        <Bottom>
                            {
                                progress >= 100 ?
                                    <Button
                                        type='right'
                                        onClick={this.clickStartLessonHandler}
                                    >
                                        直接学习
                                    </Button>
                                    : <Button
                                        type='left'
                                        onClick={this.cancelDownloadHandler}
                                    >
                                        取消
                                    </Button>
                            }
                        </Bottom>
                    </DownloadBox>
                    : <DownloadBox>
                        <TaoTao />
                        <Title>建议先下载学习内容</Title>
                        <Text>建议您先下载内容资源，学习更流畅</Text>
                        <Bottom>
                            <Button
                                type='left'
                                onClick={this.clickDownloadHandler}
                            >
                                下载资源
                            </Button>
                            <Button
                                type='right'
                                onClick={this.clickStartLessonHandler}
                            >
                                直接学习
                            </Button>
                        </Bottom>
                    </DownloadBox>
                }
            </Mask>
        );
    }
}

DownloadDialog.contextTypes = {
    user: PropTypes.object
}

const Download = styled.div`
    position: fixed;
    bottom: 0.31rem;
    right: 0.92rem;
    width: 1.07rem;
    height: 0.92rem;
    background: url(${require('./img/icon-download.png')}) no-repeat center;
    background-size: contain;
    z-index: 999;
`;

const DownloadBox = styled(HorizontalCenterDiv)`
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    padding-top: 1.54rem;
    width: 11rem;
    height: 6.8rem;
    background: #fff;
    border-radius: 0.7rem;
`;

const LoadingTaoTao = styled.div`
    position: absolute;
    top: -2.28rem;
    width: 100%;
    height: 3.42rem;
    background: url(${require('./img/background-tao-loading.png')}) no-repeat center;
    background-size: contain;
`;

const TaoTao = styled.div`
    position: absolute;
    top: -1.92rem;
    width: 100%;
    height: 3.07rem;
    background: url(${require('./img/background-tao.png')}) no-repeat center;
    background-size: contain;
`;

const Title = styled.div`
    font-size: 0.6rem;
    text-align: center;
    margin-bottom: 0.58rem;
`;

const Text = styled.div`
    margin: 0 auto;
    width: 70%;
    text-align: center;
    color: #999;
    font-size: 0.4rem;
`;

const ProgressBar = styled.div`
    margin: 0.7rem auto 0.6rem;
    position: relative;
    width: 7.7rem;
    height: 0.3rem;
    border-radius: 0.15rem;
    background: #E6E6EB;
`;

const Progress = styled.div`
    position: absolute;
    width: ${props => props.width}%;
    height: 100%;
    border-radius: 0.15rem;
    background: linear-gradient(90deg, rgba(150,235,90,1), rgba(80,200,75,1));

    &::after {
        position: absolute;
        content: '${props => props.width}%';
        display: block;
        left: 48%;
        color: #fff;
        font-size: 0.3rem;
        line-height: 0.35rem;
    }
`;

const Bottom = styled(Flex)`
    position: absolute;
    bottom: 0.7rem;
    width: 100%;
    height: 1.2rem;
    justify-content: center;
`;

const Button = styled.div`
    margin: 0 0.3rem;
    width: 4.4rem;
    height: 1.2rem;
    line-height: 1.2rem;
    text-align: center;
    border-radius: 0.6rem;
    font-size: 0.5rem;
    cursor: pointer;

    ${props => props.type && props.type === 'left' ? `
        background: #EDEDED;
        color: #666;
    ` : `
        background: linear-gradient(90deg, rgba(150,235,90,1), rgba(102,203,88,1));
        color: #fff;
    `}
`;



// WEBPACK FOOTER //
// ./src/components/lesson-path/download-dialog.js